import Grid from "@mui/material/Unstable_Grid2/Grid2";
import FormSectionGrid from "../Form/FormSectionGrid";
import FormSectionHeader from "../Form/FormSectionHeader";
import LabelValue from "./LabelValue";

const ContactInformation = ({
  pageText,
  candidateDetails,
  showGuardianFields,
}: {
  pageText: any;
  candidateDetails: any;
  showGuardianFields: boolean;
}) => {
  return (
    <>
      <FormSectionHeader>
        {pageText?.textMetadata?.contactinfotext}
      </FormSectionHeader>
      <FormSectionGrid>
        <Grid xs={12} sm={6}>
          <LabelValue
            label={pageText?.labelsMetadata.mobileLabel}
            value={candidateDetails?.phoneNo}
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <LabelValue
            label={
              pageText?.labelsMetadata.telephonenumberAlternativemobilenumber
            }
            value={candidateDetails?.telephoneNo}
          />
        </Grid>
        {!showGuardianFields && (
          <Grid xs={12}>
            <LabelValue
              label={pageText?.labelsMetadata.emailAddressLabel}
              value={candidateDetails?.email}
            />
          </Grid>
        )}
      </FormSectionGrid>
    </>
  );
};

export default ContactInformation;
